<template>
  <div
    v-if="loading"
    class="text-center p-4"
  >
    <b-spinner />
  </div>
  <div
    v-else
  >
    <div class="px-2 d-flex align-items-center border-default border-b">
      <span
        v-for="tab in tabs"
        :key="`file-tab-${tab.value}`"
        class="py-1 mr-2 tab-border"
        :class="tab.value === selectedTab ? classes.tabActive : classes.tabInactive"
        @click="selectedTab = tab.value"
      >
        {{ tab.name }}
      </span>
    </div>
    <template>
      <file-version-properties
        v-if="selectedTab === 0"
        :viewing-version-id="viewingVersionId"
        :version-data="versionData"
      />
      <file-version-metadata
        v-if="selectedTab === 1"
        :viewing-version-id="viewingVersionId"
        :version-data="versionData"
      />
    </template>
  </div>
</template>

<script>

import helpers from '@/mixins/helpers'
import FileVersionProperties from './FileVersionProperties.vue'
import FileVersionMetadata from './FileVersionMetadata.vue'

export default {
  name: 'FileViewVersion',
  mixin: [helpers],
  components: { FileVersionProperties, FileVersionMetadata },
  props: {
    viewingVersionId: {
      type: String,
      default: null,
      required: true,
    },
    versionData: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      classes: {
        tabInactive: 'text-secondary cursor-pointer',
        tabActive: 'text-main border-primary border-primary',
      },
      tabs: [
        {
          name: 'Properties',
          value: 0,
        },
        {
          name: 'Metadata',
          value: 1,
        },
      ],
      selectedTab: 0,
    }
  },
  methods: {

  },
}
</script>

<style scoped>
  .tab-border{
    border-top:none !important;
    border-left:none !important;
    border-right:none !important;
    border-bottom-width:2px !important;
    border-color:rgba(0,0,0,0);
    border-style: solid;

  }
</style>
